import { c as _c } from "react/compiler-runtime";
import { SourceType } from 'dnd-core';
import React, { ComponentProps } from 'react';
import { useDrop } from 'react-dnd';
import useDragAndDropRef from '../../hooks/useDragAndDropRef';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import { DragItem } from '../SortableListItem/SortableListItem';
import styles from './SortableListDropTarget.module.css';
export type SortableListDropTargetProps<T> = PropsWithoutChildren<Omit<ComponentProps<'div'>, 'onDrop'>> & {
  readonly dndType: SourceType;
  readonly previousItem: T | null;
  readonly nextItem: T | null;
  readonly onDrop: (dropInfo: {
    item: T;
    previousItem: T | null;
    nextItem: T | null;
  }) => void;
};
export const SortableListDropTarget = React.memo(props => {
  const $ = _c(9);
  const {
    dndType,
    previousItem,
    nextItem,
    onDrop,
    className,
    style,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const [collectedProps, dropRef] = useDrop({
    accept: dndType,
    drop: item => {
      onDrop({
        item: item.item,
        previousItem,
        nextItem
      });
    },
    collect: _temp
  });
  const ref = useDragAndDropRef(dropRef);
  const t0 = classes(className, styles.container, collectedProps.isOver ? styles.isOver : null, collectedProps.canDrop ? styles.canDrop : null);
  const t1 = collectedProps.isOver ? collectedProps.itemHeight : undefined;
  let t2;
  if ($[0] !== style || $[1] !== t1) {
    t2 = {
      ...style,
      height: t1
    };
    $[0] = style;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.extraDropArea} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== ref || $[5] !== remainingProps || $[6] !== t0 || $[7] !== t2) {
    t4 = <div ref={ref} className={t0} style={t2} {...remainingProps}>{t3}</div>;
    $[4] = ref;
    $[5] = remainingProps;
    $[6] = t0;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}) as <T>(props: SortableListDropTargetProps<T>) => React.JSX.Element;
function _temp(monitor) {
  const canDrop = monitor.canDrop();
  const isOver = monitor.isOver();
  let itemHeight;
  if (canDrop) {
    const item_0 = monitor.getItem();
    itemHeight = item_0.clientHeight;
  }
  return {
    isOver,
    canDrop,
    itemHeight
  };
}